<div class="container" [class.tablet]="isTablet" [class.mobile]="isMobile">
  <div class="main-title">{{'Contact' | translate}}</div>
  <div class="line">
    <a href="mailto:info@skalaki.com">info@skalaki.com</a>
  </div>
  <div class="line">
    Villa Skalaki {{'sur' | translate}}
    <a target="blank" href="https://www.facebook.com/Villa-Skalaki-268584207403734/">
      <i class="fab fa-facebook"></i>
    </a>
  </div>
  <div class="line">
    Villa Skalaki {{'sur' | translate}}
    <a target="blank" href="http://m.me/268584207403734">
      <i class="fab fa-facebook-messenger"></i>
    </a>
  </div>
  <div class="line">
    {{'Coordonnées' | translate}}: N 35°09.550 – E 025°55.250
  </div>
  <div class="line">
    {{'Site réalisé par' | translate}} Estelle & Romain
  </div>
  <iframe allow="geolocation" width="100%" height="450px" frameBorder="0" allowfullscreen
    src="https://umap.openstreetmap.fr/fr/map/villa-skalaki_308361?scaleControl=true&miniMap=false&scrollWheelZoom=false&zoomControl=true&allowEdit=false&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=false&onLoadPanel=undefined&captionBar=false&measureControl=false&editinosmControl=false&fullscreenControl=true"></iframe>
</div>